import {
  GeometryType,
  Layers,
  Projects,
  Tables,
  AttributeType,
  LayerDefinitionDc,
  PostgresLayerServiceConfigurationDc,
  ServiceInfoDc,
  StyleDc,
  TileServiceInfoDc,
  PostgresTileCatalogServiceConfigurationDc,
  StringSubType,
} from "@evergis/api";
import { EditGeometryType } from "../evergis/core/attributes/geometryTypes";

export type FieldTypes = AttributeType;
export const ATTRIBUTE_TYPES: AttributeType[] = [
  AttributeType.DateTime,
  AttributeType.String,
  AttributeType.Int32,
  AttributeType.Int64,
  AttributeType.Double,
];

export type Attribute = {
  name: string;
  type: FieldTypes;
  alias?: string;
  subType?: StringSubType;
};

export type AttributesDefinition = {
  displayField: string;
  idField: string;
  attributes: Attribute[];
};

export type AttributeTypesUnion<T extends AttributeType> = T;
export type GeometryAttributeType = AttributeTypesUnion<
  AttributeType.Point | AttributeType.Polyline | AttributeType.MultiPolygon | AttributeType.Multipoint
>;
export type NumberAttributeType = AttributeTypesUnion<AttributeType.Int32 | AttributeType.Int64 | AttributeType.Double>;
export type StringAttributeType = AttributeTypesUnion<AttributeType.String>;

export type AttributeSimpleType = "string" | "number" | "geometry" | "other";

export type PostgresLayerService = ServiceInfoDc & {
  configuration?: PostgresLayerServiceConfigurationDc | PostgresTileCatalogServiceConfigurationDc;
  style?: StyleDc;
  layerDefinition?: LayerDefinitionDc;
  geometryType?: GeometryType | EditGeometryType;
};

enum ServiceCategories {
  Failed = "Failed",
}

export const isFailedService = (layer?: ServiceInfoDc | TileServiceInfoDc): layer is TileServiceInfoDc =>
  layer && layer.categories && layer.categories.includes(ServiceCategories.Failed);

export const isGeometryAttribute = (type: AttributeType): type is GeometryAttributeType =>
  [AttributeType.Point, AttributeType.Polyline, AttributeType.MultiPolygon, AttributeType.Multipoint].includes(type);

export const isNumberAttribute = (type: AttributeType): type is NumberAttributeType =>
  [AttributeType.Int32, AttributeType.Int64, AttributeType.Double].includes(type);

export const isStringAttribute = (type: AttributeType): type is StringAttributeType =>
  [AttributeType.String].includes(type);

export const getAttributeSimpleType = (type: AttributeType): AttributeSimpleType => {
  if (isStringAttribute(type)) return "string";
  if (isNumberAttribute(type)) return "number";
  if (isGeometryAttribute(type)) return "geometry";

  return "other";
};

export type ResourceService = Projects | Layers | Tables;
